import { render, staticRenderFns } from "./ValidationTypeTag.vue?vue&type=template&id=78e00dca&scoped=true&"
import script from "./ValidationTypeTag.vue?vue&type=script&lang=js&"
export * from "./ValidationTypeTag.vue?vue&type=script&lang=js&"
import style0 from "./ValidationTypeTag.vue?vue&type=style&index=0&id=78e00dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e00dca",
  null
  
)

export default component.exports